import { render, staticRenderFns } from "./InsightSection.vue?vue&type=template&id=5d41a0c8&scoped=true"
import script from "./InsightSection.vue?vue&type=script&lang=js"
export * from "./InsightSection.vue?vue&type=script&lang=js"
import style0 from "./InsightSection.vue?vue&type=style&index=0&id=5d41a0c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d41a0c8",
  null
  
)

export default component.exports